import { render, staticRenderFns } from "./Organizations.vue?vue&type=template&id=51a5fa78&scoped=true&"
import script from "./Organizations.vue?vue&type=script&lang=js&"
export * from "./Organizations.vue?vue&type=script&lang=js&"
import style0 from "./Organizations.vue?vue&type=style&index=0&id=51a5fa78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a5fa78",
  null
  
)

export default component.exports